import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from '../constants/constants';
import { DominioDto } from '../dto/justino/dominio.dto';
import { environment } from '../../environments/environment';
import { DatasetDto } from '../dto/justino/dataset.dto';
import { UtilService } from './util.service';

@Injectable({
  providedIn: 'root'
})
export class DominioService {

  private apiUrl = `${environment.justinoApiUrl}/api/dominios/`;
  private datasetApiUrl = `${environment.justinoApiUrl}/api/datasets/`;

  constructor(
    private http: HttpClient) {}

  getHeaders() {
    const authToken = sessionStorage.getItem(Constants.ACCESS_TOKEN) ?? '';
    return { 
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`,
    };
  }

  // Método obtiene todos los dominios
  getDominios(): Observable<DominioDto[]> {
    return this.http.get<DominioDto[]>(this.apiUrl, { headers: this.getHeaders() });
  }

  // Método obtiene los subdominios de un dominio por id
  getSubdominiosById(id: string): Observable<DominioDto[]> {
    return this.http.get<DominioDto[]>(`${this.apiUrl}${id}/subdominios`, { headers: this.getHeaders() });
  }

  // Método obtiene un dominio por id
  getDominioById(id: string): Observable<DominioDto> {
    return this.http.get<DominioDto>(`${this.apiUrl}${id}`, { headers: this.getHeaders() });
  }

  // Método crea un dominio
  createDominio(dominio: DominioDto): Observable<DominioDto> {
    return this.http.post<DominioDto>(this.apiUrl, dominio, { headers: this.getHeaders() });
  }

  // Método crea un subdominio
  createSubdominio(dominio: DominioDto): Observable<DominioDto> {
    return this.http.post<DominioDto>(`${this.apiUrl}${dominio.ParentId}/subdominios`, dominio, { headers: this.getHeaders() });
  }

  // Método actualiza un dominio
  updateDominio(id: string, dominio: DominioDto): Observable<DominioDto> {
    return this.http.put<DominioDto>(`${this.apiUrl}${id}`, dominio, { headers: this.getHeaders() });
  }

  // Método elimina un dominio
  deleteDominio(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}${id}`, { headers: this.getHeaders() });
  }

  // Metodo envia solicitud procesamiento de video
  sendVideoProcessRequest(dominio: DominioDto, appendFlag: boolean): Observable<any> {
    const processVideoUrl = `${environment.justinoApiUrl}/api/transcribe/`;
    const { videoUrl } = dominio;
    return this.http.post<any>(processVideoUrl, { 
      url: videoUrl, 
      dominioId: dominio.Id,
      appendFlag: appendFlag
    }, { headers: this.getHeaders() });
  }

  // Metodo para obtener el contenido del dataset del dominio
  getDataSetContent(datasetId: string): Observable<DatasetDto> {
    return this.http.get<DatasetDto>(`${this.datasetApiUrl}${datasetId}`, { headers: this.getHeaders() });
  }

  // Metodo para actualizar el contenido del dataset del dominio
  updateContenidoDatasetDominio(dataset: DatasetDto): Observable<void>{
    const { Id } = dataset;
    return this.http.put<void>(`${this.datasetApiUrl}${Id}`, dataset, { headers: this.getHeaders() });
  }
  
  // Metodo para eliminar el registro de un dataset
  deleteDataSet(datasetId: string, domainId: string): Observable<void>{
    const body = { datasetId, domainId };
    return this.http.delete<void>(`${this.datasetApiUrl}${datasetId}`, { body, headers: this.getHeaders() });
  }
}